/**
 * Generate a formatted date string (YYYY-MM-DD) from a Date object.
 * USefull for form in the browser
 * @param date 
 * @returns 
 */
export function getFormattedDate(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}